document.addEventListener("DOMContentLoaded", function() {
    const overlay = document.getElementById("main-popup-overlay");
    const popupBanner = document.getElementById("main-popup-banner");
    const closePopup = document.getElementById("closePopup");
    const popupButton = document.querySelector(".main-popup-banner-button");
    setTimeout(() => {
      if (localStorage.getItem("popupClosed") !== "true") {
        overlay.style.display = "block";
        popupBanner.style.display = "block";
      }
    }, 2500);
  
      closePopup.addEventListener("click", function(e) {
        e.preventDefault();
        overlay.style.display = "none";
        popupBanner.style.display = "none";
  
        localStorage.setItem("popupClosed", "true");
      });

      if (popupButton) {
        popupButton.addEventListener("click", function(e) {
            if (localStorage.getItem("popupClosed") === "true") {
                e.preventDefault();
            } else {
                closePopupFunction();
            }
        });
      }
  
      function closePopupFunction() {
          overlay.style.display = "none";
          popupBanner.style.display = "none";
          localStorage.setItem("popupClosed", "true");
      }
    
    function updateImageSource() {
      const mainPopupImage = document.querySelector(".main-popup-image img");
      const screenWidth = window.innerWidth;
      if (screenWidth <= 501) {
        // Small gif
        mainPopupImage.src = "https://cdn.shopify.com/s/files/1/0273/0603/3289/files/popup-banner-mrl-m.gif?v=1711231993"; 
        popupButton.innerText = "ZUR AKTIONSSEITE";
      } else {
        // Big gif
        mainPopupImage.src = "https://cdn.shopify.com/s/files/1/0273/0603/3289/files/popup-banner-mrl-d.gif?v=1711231993";
        popupButton.innerText = "ZU DEN TOYS";
      }
    }
  
    updateImageSource();
  
    window.addEventListener("resize", updateImageSource);
});
  